import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  medium: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

interface propsAvatar{
  image:string
  abrv: string
}

const AvatarImg = ({image,abrv }:propsAvatar) => {  
  const classes = useStyles();
  return (
  <>
  {
    image !== null ?
    <Avatar alt={`${abrv}`} src={`${image}`} className={classes.medium} />:
    <Avatar className={classes.medium}>{`${abrv}`}</Avatar>
    }
  </>
  )
}

export default AvatarImg